import Vue from 'vue'
import Router from 'vue-router'
import index from '../view/index.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/kjxazbqmyxzjpro',
  routes: [
	{
		name:'index',
		path:'/index',
		component:index
	}
  ]
})
